import { ApprovalStatusTypeEnum, WeighingTypeEnum } from "../../domain/model/model-enums";
import { Uuid } from "../../domain/model/uuid/uuid.type";
import { WeighingType } from "../../domain/model/weighing-type";
import { ApprovalStatusViewModel } from "../shared/approval-status.viewmodel";

export class SectionOverviewBatchRowWeighingViewModel {
  constructor(
  readonly batchWeighingId: Uuid,
  readonly batchNumber: number,
  readonly weighingType: WeighingType,
  readonly averageWeight: number,
  readonly date: Date | null,
  readonly interimSequenceNumber: number | null,
  readonly approval: ApprovalStatusViewModel | null) {
   }

   isPendingApproval(): boolean {
      return this.approval !== null &&
      (this.approval.status.status === ApprovalStatusTypeEnum.Pending ||
        (this.approval.status.status !== ApprovalStatusTypeEnum.Approved &&
          this.approval.status.status !== ApprovalStatusTypeEnum.Rejected)
        );
   }

   isApproved(): boolean {
      return this.approval !== null && this.approval.status.status === ApprovalStatusTypeEnum.Approved;
    }

   isRejected(): boolean {
    return this.approval !== null && this.approval.status.status === ApprovalStatusTypeEnum.Rejected;
  }

   isInitial(): boolean {
     return this.weighingType.type === WeighingTypeEnum.Initial;
   }

   isFinal(): boolean {
     return this.weighingType.type === WeighingTypeEnum.Final;
   }
}
